import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import logo from "../assets/SAFYLogo.png";

function RCSafyInvoice(props) {
  const location = useLocation();
  const billingRules = location.state.billingRules;
  const bedDays = location.state.bedDays;
  const payors = location.state.payors;
  const passedData = location.state.data;
  const [censusPayor, setCensusPayor] = useState(
    payors.filter(
      (payor) => payor.ccx_payor["@name"] === bedDays[0].rule.payor
    )[0]
  );

  return (
    <div>
      <div className="row">
        <div className="col-3 ">
          <img src={logo} alt="logo" style={{ width: "200px" }}></img>
          <div className="mt-2 text-primary">
            Specialized Alternatives for Families & Youth
          </div>
        </div>
      </div>
      <div className="row justify-content-center mb-4">
        <div className="col-4">
          <div className="row">
            <div className="col-3 fw-bold">Bill To:</div>
            <div className="col-9">
              <div>{censusPayor?.ccx_payor["@name"]}</div>
              <div>{censusPayor?.ccx_groupplanpayoraddress["@name"]}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="row my-4">
        <div className="col">
          <div>10100 Elida Rd, Delphos OH 45833</div>
          <div>(419) 695-8010</div>
          <div>Contact: Kathy Vorst</div>
        </div>
        <div className="col">
          <div>{`Contract With: ${censusPayor?.ccx_payor["@name"]}`}</div>
          <div>Fed I.D. #</div>
          <div>{`Invoice Date: ${new Date().toLocaleDateString()}`}</div>
          <div>{`Services Dates: ${passedData.startDate} - ${passedData.endDate}`}</div>
          <div>Invoice #</div>
        </div>
        <div className="col">
          <div>
            <div className="fw-bold d-flex"></div>
            <div>{bedDays[0].ccx_clientprogram["@name"].split("-")[0]}</div>
          </div>
        </div>
      </div>
      <div className="row mt-4">
        <div className="col fw-bold">Last Name</div>
        <div className="col fw-bold">First Name</div>
        <div className="col fw-bold">Date of Service</div>
        <div className="col fw-bold">Per Diem</div>
      </div>
      {bedDays.map((bedDay, index) => {
        if (bedDay.rule.rate !== 0) {
          return (
            <div className="row" key={`bd${bedDay.ccx_recorded_serviceid}`}>
              <div className="col">
                {bedDay?.ccx_patient["@name"].split(",")[0]}
              </div>
              <div className="col">
                {bedDay?.ccx_patient["@name"].split(",")[1]}
              </div>
              <div className="col">{bedDay.ccx_starttime["@date"]}</div>
              <div className="col">{bedDay.rule.rate.toFixed(2)}</div>
            </div>
          );
        }
      })}
      <div className="row mt-1 mb-4">
        <div className="col-9">
          {" "}
          I certify, to the best of my knowledge, that the above information is
          accurate
        </div>
        <div className="col-3 fw-bold">
          <div>Total Billing Amount</div>
          <div>
            {bedDays
              .reduce(
                (total, bd) =>
                  total + (bd.rule.rate !== null ? bd.rule.rate : 0),
                0
              )
              .toLocaleString()}
          </div>
        </div>
      </div>
      <div className="row mt-4">
        <div className="col"></div>
        <div className="col">Account Manager</div>
        <div className="col">{new Date().toLocaleDateString()}</div>
      </div>
      <div className="row fw-bold mb-4">
        <div className="col">Signature</div>
        <div className="col">Title</div>
        <div className="col">Date</div>
      </div>
    </div>
  );
}

export default RCSafyInvoice;
